import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import './AuthModal.css';

export default function AuthModal({ onClose, onSuccess, initialMode = 'login', reason = null }) {
  const { signInWithGoogle, signInWithEmail, signUpWithEmail } = useAuth();
  const [mode, setMode] = useState(initialMode);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleGoogle = async () => {
    setError('');
    await signInWithGoogle();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        const { error } = await signInWithEmail(email, password);
        if (error) { setError(error.message); }
        else { onSuccess && onSuccess(); onClose && onClose(); }
      } else {
        if (!displayName.trim()) { setError('Please enter your name.'); setLoading(false); return; }
        const { error } = await signUpWithEmail(email, password, displayName);
        if (error) { setError(error.message); }
        else { setEmailSent(true); }
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  if (emailSent) {
    return (
      <div className="auth-backdrop" onClick={onClose}>
        <div className="auth-modal" onClick={e => e.stopPropagation()}>
          <img src={'/ovr-logo.png'} alt="OVR" className="auth-logo" />
          <div className="auth-eyebrow">Check your inbox</div>
          <h2 className="auth-title">CONFIRM YOUR <em>EMAIL</em></h2>
          <p className="auth-body">We sent a confirmation link to <b>{email}</b>. Click it to activate your account, then come back and sign in.</p>
          <button className="auth-btn primary" onClick={onClose}>GOT IT</button>
          <p className="auth-tagline">THE COURT IS WAITING.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-backdrop" onClick={onClose}>
      <div className="auth-modal" onClick={e => e.stopPropagation()}>
        <button className="auth-close" onClick={onClose}>✕</button>

        <img src={'/ovr-logo.png'} alt="OVR" className="auth-logo" />

        <div className="auth-eyebrow">
          {reason === 'checkout' ? 'One last step' : 'Ottawa Volleyball Revival'}
        </div>
        <h2 className="auth-title">
          {reason === 'checkout'
            ? <>YOU'RE <em>ALMOST THERE</em></>
            : mode === 'login' ? <>WELCOME <em>BACK</em></> : <>JOIN THE <em>SQUAD</em></>}
        </h2>
        {reason === 'checkout' && (
          <p className="auth-body" style={{ marginTop: -8, marginBottom: 18 }}>
            Sign in or create an account to lock in your spot.
          </p>
        )}

        <button className="auth-google-btn" onClick={handleGoogle}>
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 6.29C4.672 4.163 6.656 3.58 9 3.58z"/>
          </svg>
          CONTINUE WITH GOOGLE
        </button>

        <div className="auth-divider"><span>OR</span></div>

        <form onSubmit={handleSubmit} className="auth-form">
          {mode === 'signup' && (
            <input className="auth-input" type="text" placeholder="Your name"
              value={displayName} onChange={e => setDisplayName(e.target.value)} required />
          )}
          <input className="auth-input" type="email" placeholder="Email address"
            value={email} onChange={e => setEmail(e.target.value)} required />
          <input className="auth-input" type="password" placeholder="Password"
            value={password} onChange={e => setPassword(e.target.value)} required minLength={6} />
          {error && <div className="auth-error">{error}</div>}
          <button className="auth-btn primary" type="submit" disabled={loading}>
            {loading ? 'LOADING...' : mode === 'login' ? 'SIGN IN →' : 'JOIN THE SQUAD →'}
          </button>
        </form>

        <div className="auth-switch">
          {mode === 'login' ? (
            <>New here? <button onClick={() => { setMode('signup'); setError(''); }}>Sign up and join the squad</button></>
          ) : (
            <>Already with us? <button onClick={() => { setMode('login'); setError(''); }}>Sign in</button></>
          )}
        </div>

        <p className="auth-tagline">
          {mode === 'login' ? 'THE COURT IS WAITING.' : 'DROP IN. LOCK IN. BALL OUT.'}
        </p>
      </div>
    </div>
  );
}
